export const useIsEditing = (): boolean => {
  return window.location.href.includes('/edit');
};
